export default __webpack_public_path__ + "static/media/logisticTime.8768cbb3.svg";